export function sortObjectByArray (sortingObject, sortingObjectProperty, sortingArray) {
    return sortingObject.sort((a, b) => {
        let aIndex = sortingArray.indexOf(a[sortingObjectProperty]);
        let bIndex = sortingArray.indexOf(b[sortingObjectProperty]);
        if(aIndex < 0) {
            aIndex = 1000;
        }
        if(bIndex < 0) {
            bIndex = 999;
        }
        return aIndex - bIndex;
    })
}

export function sortArrayByObject (sortingArray, sortingObject, sortingObjectProperty) {
    return sortingArray.sort((a, b) => {
        let aIndex = sortingObject.findIndex(option => option[sortingObjectProperty] === a);
        let bIndex = sortingObject.findIndex(option => option[sortingObjectProperty] === b);
        return aIndex - bIndex;
    })
}
